
import { Component, Vue, Ref } from 'vue-property-decorator'
import { registerNiceModalComponent } from '@xt/client/utils/messageModalQueue/index'
import type {
  ModalQueueItem,
  TopicTipProps,
  GiftProps,
  CouponProps,
  IMessageResp,
  ConfirmModalResult
} from '@xt/client/utils/messageModalQueue/types.d.ts'
import { EnumModalQueueItemType, EnumRegisterModalNames, EnumModalQueueItemCode } from '@xt/client/enums/messageModalQueue/index'
import { Observer } from 'mobx-vue'
import type { BaseCouponItem } from '@xt/client/types/coupon'
import { EnumApiNotice } from '@xt/client/api/notice'
import { $service } from '@xt/client/experimental/request/service'

registerNiceModalComponent()

@Observer
@Component({
  components: {}
})
export default class MessageModalQueue extends Vue {
  modalQueue: Array<ModalQueueItem> = []
  consumerStarted: boolean = false

  tansformQueueItem(data: IMessageResp): ModalQueueItem | null {
    switch (data.noticeSubType) {
      case EnumModalQueueItemCode.Recruit:
        return this.transformTopicTipProps(data, EnumModalQueueItemType.Recruit)
      case EnumModalQueueItemCode.Init:
        return this.transformTopicTipProps(data, EnumModalQueueItemType.Init)
      case EnumModalQueueItemCode.Exit:
        return this.transformTopicTipProps(data, EnumModalQueueItemType.Exit)
      case EnumModalQueueItemCode.Gift:
        return this.transformGiftProps(data)
      case EnumModalQueueItemCode.Coupon:
        return this.transformCouponProps(data)
      default:
        return null
    }
  }

  transformCouponProps(data: IMessageResp): CouponProps {
    return {
      id: data.id,
      successList: data.bizData!.jsonContent! as unknown as Array<BaseCouponItem>,
      failList: [],
      type: EnumModalQueueItemType.Coupon
    }
  }

  transformGiftProps(data: any): GiftProps {
    return {
      ...data,
      type: EnumModalQueueItemType.Gift
    }
  }

  mapTopicTipProps(
    parsed: {
      regionName: string
    },
    type: EnumModalQueueItemType
  ) {
    let data: {
      title: string
      subTitle: string
      description: string
      backgroundUrl?: string
      hideCancel?: boolean
      confirmText?: string
    } | null = null

    switch (type) {
      case EnumModalQueueItemType.Init:
        data = {
          title: `${parsed.regionName}分桐`,
          subTitle: '成功开启啦~',
          description: `恭喜${parsed.regionName}桐好，今后笔墨相伴，常赴雅约`
        }
        break
      case EnumModalQueueItemType.Recruit:
        data = {
          title: `${parsed.regionName}分桐`,
          subTitle: '助力成功',
          description: '分桐负责人招募开启'
        }
        break
      case EnumModalQueueItemType.Exit:
        data = {
          title: `您已退出${parsed.regionName}分桐`,
          subTitle: '',
          description: '如需加入其他分桐，可前往桐学会页面提交申请',
          backgroundUrl: '',
          hideCancel: true,
          confirmText: '确认'
        }
        break
    }
    return data
  }

  transformTopicTipProps(data: IMessageResp, type: EnumModalQueueItemType): TopicTipProps | null {
    const parsed = JSON.parse(data.bizData!.jsonContent!) as { regionName: string; guildName: string }

    const dataMap = this.mapTopicTipProps(parsed, type)

    // 匹配不到的类型不加入队列
    if (!dataMap) return null

    return {
      id: data.id,
      bizId: data.bizId,
      backgroundUrl: `${this.$store.$global.static}/images/topic/pc/${type}-pop-bg.png`,
      layoutClassName: type ? `${type}-confirm-modal` : 'congratulate-confirm-modal',
      type,
      ...dataMap
    }
  }

  /** 拉取消息生成弹窗队列 */
  async checkShowCongratulateModal() {
    if (!this.$store.$storeUser.UserInfo.id) return

    const res = await this.$store.$storeUser.messageNotice.onLoadPop()

    if (!res.length) return

    res.forEach(item => {
      let queueItem: ModalQueueItem | null = null

      queueItem = this.tansformQueueItem(item)

      if (queueItem) this.modalQueue.push(queueItem)
    })

    console.log('checkShowCongratulateModal', this.modalQueue)
  }

  async onReadNotice(id: number) {
    const [, resp] = await $service<boolean>({
      url: EnumApiNotice.noticeRead,
      method: 'post',
      data: {
        id
      }
    })

    return resp === true
  }

  private async startConsumer() {
    try {
      if (this.consumerStarted) return

      this.consumerStarted = true

      for (const item of this.modalQueue) {
        // 弹窗出现则已读
        await this.onReadNotice(item.id)

        if ([EnumModalQueueItemType.Init, EnumModalQueueItemType.Recruit, EnumModalQueueItemType.Exit].includes(item.type)) {
          const res: ConfirmModalResult = await this.$niceModal.show(EnumRegisterModalNames.Topic, item)
          if (res.status === 'ok') {
            console.log('consumeModalQueue success', res)
          }
        } else if (item.type === EnumModalQueueItemType.Gift) {
          await this.$niceModal.show(EnumRegisterModalNames.Gift, {
            dataSource: item
          })
        } else if (item.type === EnumModalQueueItemType.Coupon) {
          await this.$niceModal.show(EnumRegisterModalNames.Coupon, {
            data: item
          })
        }

        await this.$sleep(100) // 可选短延迟以避免 UI 闪烁
      }
    } catch (err) {
      console.error('consumer unexpected error', err)
    }
  }

  async created(): Promise<void> {
    await this.checkShowCongratulateModal()
    this.startConsumer()
  }

  destroyed(): void {}
}
